import { render } from "./TransferInput.vue?vue&type=template&id=f9b1a618&scoped=true"
import script from "./TransferInput.vue?vue&type=script&lang=js"
export * from "./TransferInput.vue?vue&type=script&lang=js"

import "./TransferInput.vue?vue&type=style&index=0&id=f9b1a618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b1a618"]])

export default __exports__